(function (root, factory) {
  var api = factory(root);

  root.PjDesignLabPreviewModal = api;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  function createPreviewModalController(doc) {
    var previousOverflow = '';
    var scrollLocked = false;
    var wiredModal = null;
    var keydownWired = false;
    var toastTimer = null;

    function modalEl() {
      return doc.getElementById('pvModal');
    }

    // Product sections sit in their own stacking context, so a z-index alone
    // loses to the fixed header. Same approach as the gallery lightbox.
    function portalToBody(modal) {
      var body = doc.body;
      if (!body || typeof body.appendChild !== 'function') return;
      if (modal.dataset && modal.dataset.pvPortaled === 'true') return;

      if (typeof body.querySelectorAll === 'function') {
        Array.prototype.forEach.call(
          body.querySelectorAll('.pv-modal[data-pv-portaled="true"]'),
          function (stale) {
            if (stale !== modal && typeof stale.remove === 'function') stale.remove();
          }
        );
      }

      body.appendChild(modal);
      if (modal.dataset) modal.dataset.pvPortaled = 'true';
    }

    function loadingController() {
      return root.PjDesignLabPreviewLoading;
    }

    function controlsController() {
      return root.PjDesignLabControls;
    }

    // Capture the page's own overflow only on the first open. Re-capturing on a
    // second open would store this lock's own 'hidden' and strand the page
    // unscrollable after close.
    function lockScroll() {
      if (scrollLocked) return;
      previousOverflow = doc.body.style.overflow;
      doc.body.style.overflow = 'hidden';
      scrollLocked = true;
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      doc.body.style.overflow = previousOverflow;
      previousOverflow = '';
      scrollLocked = false;
    }

    function openPreview(context) {
      var modal = modalEl();
      if (!modal) return;

      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();

      var closeBtn = doc.getElementById('pvXBtn');
      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();

      var controls = controlsController();
      var previewContext = context || {};
      if (controls && typeof controls.setContext === 'function') {
        previewContext = controls.setContext(previewContext);
      }

      var renderer = root.PjDesignLabRenderer;
      if (renderer && typeof renderer.resetZoom === 'function') {
        renderer.resetZoom();
      }
      if (renderer && typeof renderer.setContext === 'function') {
        renderer.setContext(previewContext);
      }

      startPreparation(previewContext);
    }

    /**
     * Runs the loading sequence, unless everything it would prepare is already
     * cached - reopening a Lab that is ready opens straight onto it rather than
     * replaying a wait for work already done.
     */
    function startPreparation(previewContext) {
      var loading = loadingController();
      if (!loading) return;

      var controls = controlsController();
      var ready =
        controls &&
        typeof controls.isPreparedForDisplay === 'function' &&
        controls.isPreparedForDisplay();

      if (ready && typeof loading.showReady === 'function') {
        loading.showReady();
        return;
      }

      if (typeof loading.start === 'function') loading.start(previewContext);
    }

    // Retry after a whole-preview failure: the uploaded photos are untouched,
    // so preparation simply runs again over the same context.
    function onPreviewRetry() {
      var controls = controlsController();
      var context =
        controls && typeof controls.rendererContext === 'function'
          ? controls.rendererContext()
          : {};
      startPreparation(context);
    }

    function closePv() {
      var modal = modalEl();
      if (!modal) return;

      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();

      var loading = loadingController();
      if (loading && typeof loading.cancel === 'function') loading.cancel();
    }

    // Shares the PDP's #surge-pdp-toast element and styles (product.css) so the
    // two toasts never stack. Only the modal is closed by now, so the page
    // mount is always right.
    function showToast(message) {
      var toast = doc.getElementById('surge-pdp-toast');
      if (!toast) {
        toast = doc.createElement('div');
        toast.id = 'surge-pdp-toast';
        toast.className = 'surge-toast';
        toast.innerHTML =
          '<div class="surge-toast-check">' +
          '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7 L5 10 L12 3"/></svg>' +
          '</div>' +
          '<span class="surge-toast-message"></span>';
        doc.body.appendChild(toast);
      }
      toast.style.background = '#111827';
      var messageEl = toast.querySelector('.surge-toast-message');
      if (messageEl) messageEl.textContent = message;
      toast.classList.add('show');

      if (toastTimer) root.clearTimeout(toastTimer);
      toastTimer = root.setTimeout(function () {
        toast.classList.remove('show');
      }, 2800);
    }

    function onFinalize() {
      var controls = controlsController();
      var committed =
        controls && typeof controls.finalize === 'function' && controls.finalize();
      if (!committed) return;

      var analytics = root.PjAnalytics;
      if (analytics) analytics.finalized(committed.design);
      closePv();
      showToast(
        committed.petCount > 1
          ? 'Customization saved \u2014 ' + committed.petCount + ' pets'
          : 'Customization saved'
      );
    }

    function onBackdropClick(event) {
      if (event.target === event.currentTarget) closePv();
    }

    function onKeydown(event) {
      if (event.key !== 'Escape') return;
      var modal = modalEl();
      if (modal && modal.classList.contains('open')) closePv();
    }

    function init() {
      var modal = modalEl();
      if (!modal) return;

      portalToBody(modal);

      var controls = controlsController();
      if (controls && typeof controls.init === 'function') controls.init();

      if (wiredModal !== modal) {
        wiredModal = modal;
        modal.addEventListener('click', onBackdropClick);

        var closeBtn = doc.getElementById('pvXBtn');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (event) {
            event.preventDefault();
            closePv();
          });
        }

        var finalizeBtn = doc.getElementById('pvFinalize');
        if (finalizeBtn) {
          finalizeBtn.addEventListener('click', function (event) {
            event.preventDefault();
            onFinalize();
          });
        }

        var previewRetry = doc.getElementById('pvPreviewRetry');
        if (previewRetry) {
          previewRetry.addEventListener('click', function (event) {
            event.preventDefault();
            onPreviewRetry();
          });
        }
      }

      if (!keydownWired) {
        keydownWired = true;
        doc.addEventListener('keydown', onKeydown);
      }
    }

    return {
      openPreview: openPreview,
      closePv: closePv,
      onFinalize: onFinalize,
      init: init,
    };
  }

  var controller = root.document ? createPreviewModalController(root.document) : null;

  if (controller) {
    root.openPreview = controller.openPreview;
    root.closePv = controller.closePv;

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', controller.init, {
        once: true,
      });
    } else {
      controller.init();
    }
  }

  return {
    createPreviewModalController: createPreviewModalController,
    openPreview: controller && controller.openPreview,
    closePv: controller && controller.closePv,
    init: controller && controller.init,
  };
});
